function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { canMangeIntegrationsKey, getCanManageIntegrations } from '@repo/guards/org';
import { useQuery } from '@tanstack/react-query';
import { useCurrentUser } from './current-user';
export const queryKeys = createQueryKeys('user-can-manage-deployment-integrations', {
    can: (param)=>{
        let { organization, user } = param;
        return {
            queryKey: [
                canMangeIntegrationsKey,
                organization === null || organization === void 0 ? void 0 : organization.id,
                user === null || user === void 0 ? void 0 : user.id
            ],
            queryFn: async ()=>{
                if (!organization || !user) {
                    return Promise.resolve(false);
                }
                return getCanManageIntegrations(organization, user);
            }
        };
    }
});
export function useUserCanManageDeploymentIntegrations(params) {
    const { user } = useCurrentUser();
    const { isLoading, data: can, error } = useQuery(queryKeys.can(_object_spread_props(_object_spread({}, params), {
        user
    })));
    return {
        can,
        isLoading,
        error
    };
}
